<div class="top-section">
  <div class="flex items-center">
    <app-svg name="hamburger" class="common-hamburger" (click)="ss.toggleSidebar()" role="button"
      [color]="cc.isNarrowScreen() ? ss.theme().color12 : ss.theme().color8"></app-svg>
    <!-- Show Mevolve logo when all features are disabled OR only non-date features (Note/List) are enabled -->
    <ng-container
      *ngIf="featureStore.allFeaturesDisabled() || featureStore.onlyNonDateFeaturesEnabled(); else showTitle">
      <div class="flex-1 flex justify-center">
        <app-svg [name]="brandLogo" [color]="cc.isNarrowScreen() ? ss.theme().color12 : ss.theme().color8"
          [height]="'24px'"></app-svg>
      </div>
    </ng-container>
    <ng-template #showTitle>
      <h4 class="heading mb-0">{{ config()[mode()].name }}</h4>
    </ng-template>
  </div>
  <div class="flex items-center gap-6"
    *ngIf="!featureStore.allFeaturesDisabled() && !featureStore.onlyNonDateFeaturesEnabled()">
    <app-notification [iconColor]="cc.isNarrowScreen() ? ss.theme().color12 : null"></app-notification>
    <app-svg *ngIf="!isEmpty() || isFilter()" [name]="isFilter() ? 'filterOutline' : 'filter'" class="icon-mirror-rtl"
      [color]="cc.isNarrowScreen() ? ss.theme().color12 : ss.theme().color8" role="button"
      (click)="toggleFilter()"></app-svg>
    <app-svg name="more" [color]="cc.isNarrowScreen() ? ss.theme().color12 : ss.theme().color8" [height]="'24px'"
      [width]="'24px'" (click)="openView()" role="button"></app-svg>
  </div>
</div>

<div class="body-section">
  <!-- Show all-features-disabled empty state when all features are turned off OR only non-date features (Note/List) are enabled -->
  <ng-container
    *ngIf="featureStore.allFeaturesDisabled() || featureStore.onlyNonDateFeaturesEnabled(); else showContent">
    <app-all-features-disabled-block></app-all-features-disabled-block>
  </ng-container>

  <ng-template #showContent>
    <div class="filter-block" [ngClass]="{'h-auto filtered': isFilter() }" dragScroll>
      <app-filter-search [signal]="filters.query" [name]="'todo'" class="me-2"
        *ngIf="!isFocusSelected()"></app-filter-search>
      <app-filter-feature [value]="filters.feature" [hiddenValues]="mode() === 'FUTURE' ? ['list','note'] : ['list']"
        class="me-2" [multiple]="true"></app-filter-feature>
      <app-filter-hashtag [signal]="filters.tags" class="me-2" *ngIf="!isFocusSelected()"></app-filter-hashtag>
      <app-filter-attachment [signal]=" filters.attachments" [multiple]="true" class="me-2"
        *ngIf="!isFocusSelected()"></app-filter-attachment>
      <app-filter-status [value]="filters.status" class="me-2" [multiple]="true" *ngIf="!isFocusSelected()"
        [hiddenValues]="mode() === 'FUTURE' ? ['incomplete'] : []"></app-filter-status>
      <app-filter-mood [signal]="filters.moods" [multiple]="true" class="me-2"
        *ngIf="!isFocusSelected() && hasJournalDataInTimeRange()"></app-filter-mood>
      <app-filter-role [value]="filters.role" class="me-2" [multiple]="true"
        [hiddenValues]="isFocusSelected() ? ['editor'] : []"></app-filter-role>
      <app-filter-date-range [startDate]="filters.startDate" [endDate]="filters.endDate" class="me-2"
        [minDate]="minDate()" [maxDate]="maxDate()"></app-filter-date-range>
      <button class="btn btn-filter btn-clear" (click)="clearFilters()" *ngIf="isFiltered()">{{
        ss.t('common_clearAll') }}
      </button>
    </div>


    <!-- Show loader while initial data is loading -->
    <app-loader *ngIf="loading()" style="margin-top:40px !important;" [noBackdrop]="true"
      [noBackdropShadow]="true"></app-loader>

    <!-- Entities wrapper -->
    <div class="entities-wrapper" *ngIf="!isEmpty() && !loading()">

      <!-- Sticky header overlay (fixed at top, updates as you scroll) -->
      <div class="sticky-header-overlay" *ngIf="currentStickyHeader()">
        <div class="group-title text-16-400 ri-px-4 ri-py-3 ri-bb-2 flex justify-between items-center"
          [style.border-radius]="!cc.isNarrowScreen() ? '8px' : null"
          (click)="toggleGroupExpansion(currentStickyHeader()!.id)" role="button">
          <span class="color-35">{{ currentStickyHeader()?.name }}</span>
          <span class="group-count flex items-center" *ngIf="showCounts()">
            {{ currentStickyHeader()?.count }}
          </span>
        </div>
      </div>

      <!-- Scrollable container -->
      <div class="entities-block" (scroll)="onScroll($event)" #scrollContainer>

        <!-- Simple ngFor - no virtualization! -->
        <div *ngFor="let item of flatenedData(); trackBy: trackByFlattened">

          <!-- Group Header -->
          <ng-container *ngIf="item.type === 'header' && item.count > 0">
            <div class="group-header" [attr.data-header-id]="item.id" (click)="toggleGroupExpansion(item.id)"
              role="button">
              <div class="group-title text-16-400 ri-px-4 ri-py-3 ri-bb-2 flex justify-between items-center"
                [style.border-radius]="!cc.isNarrowScreen() ? '8px' : null">
                <span class="color-35">{{ item.name }}</span>
                <span class="group-count flex items-center" *ngIf="showCounts()">{{ item.count }}</span>
              </div>
            </div>
          </ng-container>

          <!-- Group Items -->
          <ng-container *ngIf="item.type === 'item' && item.entry">
            <div class="entity-item" [attr.id]="'allEntityGroup' + item.groupIndex"
              [class.collapsed]="!isGroupExpanded(item.groupId)">

              <app-todo-block class="ri-bb-2 entity-block" [blockClass]="'ri-px-4 ri-py-3'"
                [dateString]="item.dateString" [entry]="$any(item.entry)" [show]="showConfig()"
                [descriptionType]="descriptionType()" *ngIf="item.entry.entityType === 'todo'">
              </app-todo-block>

              <app-habit-block class="ri-bb-2 entity-block" [blockClass]="'ri-px-4 ri-py-3'"
                [dateString]="item.dateString" [entry]="$any(item.entry)" [show]="showConfig()"
                [descriptionType]="descriptionType()" *ngIf="item.entry.entityType === 'habit'">
              </app-habit-block>

              <app-journal-block class="ri-bb-2 entity-block" [blockClass]="'ri-px-4 ri-py-3'"
                [dateString]="item.dateString" [entry]="$any(item.entry)" [show]="showConfig()"
                [descriptionType]="descriptionType()" *ngIf="item.entry.entityType === 'journal'">
              </app-journal-block>

              <app-money-tracker-block class="ri-bb-2 entity-block" [blockClass]="'ri-px-4 ri-py-3'"
                [show]="showConfig()" [descriptionType]="descriptionType()" [entry]="$any(item.entry)"
                *ngIf="item.entry.entityType === 'moneyTracker'">
              </app-money-tracker-block>

              <app-calendar-event-block class="ri-bb-2 entity-block" [blockClass]="'ri-px-4 ri-py-3'"
                [dateString]="item.dateString" [entry]="$any(item.entry)" [show]="showConfig()"
                [descriptionType]="descriptionType()" *ngIf="item.entry.entityType === 'calendarIntegration'">
              </app-calendar-event-block>

              <app-focus-block class="ri-bb-2 entity-block" [blockClass]="'ri-px-4 ri-py-3'"
                [dateString]="item.dateString" [entry]="$any(item.entry)" [show]="showConfig()"
                [showAttemptCount]="mode() !== 'FUTURE'" *ngIf="item.entry.entityType === 'focus'">
              </app-focus-block>

              <app-note-block class="ri-bb-2 entity-block" [blockClass]="'ri-px-4 ri-py-3'" [noteId]="item.entry.setupId"
                [show]="showConfig()" [descriptionType]="descriptionType()" *ngIf="item.entry.entityType === 'note'">
              </app-note-block>
            </div>
          </ng-container>
        </div>

        <!-- Loading more indicator - floating above bottom bars -->
        <div class="loading-more-floating" [style.display]="loadingMore() ? 'flex' : 'none'">
          <app-loader [noBackdrop]="true" [noBackdropShadow]="true" [size]="'small'"></app-loader>
        </div>

        <!-- Sentinel element for IntersectionObserver (invisible trigger) -->
        <div #loadMoreSentinel class="load-more-sentinel" *ngIf="hasMore() && !loadingMore()"></div>

      </div>
    </div>

    <app-no-result-block class="no-result-block" [message]="ss.t('common_noResultFound')"
      [imagePlaceholder]="'searchPlaceholder'" *ngIf="isEmpty() && !loading() && isFilter()"
      [showQuickGuide]="false"></app-no-result-block>

    <app-no-result-block class="no-result-block" [message]="ss.t('common_emptyContent')"
      [imagePlaceholder]="'featuresPlaceholder'" *ngIf="isEmpty() && !loading() && !isFilter()"></app-no-result-block>
  </ng-template>
</div>
<!-- Bottom Bar (all screen sizes) -->
<app-mobile-bottom-bar></app-mobile-bottom-bar>